import {
	ChangeDetectionStrategy,
	Component,
	Output,
	EventEmitter,
} from '@angular/core';
import { ICON } from '@core/util/icon';
import { FireInsuranceAgent } from '@models/brokerage';
import { Store } from '@ngxs/store';
import {
	FireInsuranceAgentsDispatch,
	FireInsuranceAgentsSearchState,
} from '@state/algolia-search/fire-insurance-agents-search';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { DropdownResult } from 'src/app/shared/atomic/atoms/dropdown-options/dropdown-options.component';

export enum DropdownSelect {
	SELECT_FIRE_INSURANCE_AGENT = 'SELECT_FIRE_INSURANCE_AGENT',
}

@Component({
	selector: 'app-search-fire-insurance-agent',
	templateUrl: './search-fire-insurance-agent.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class SearchFireInsuranceAgentComponent {
	public dropdownSelect = DropdownSelect;
	public ICON = ICON;
	public loading = false;
	public searchTerm: string;
	public selected;

	public fireInsuranceAgents$ = this.store.select(
		FireInsuranceAgentsSearchState.getList,
	);
	public isSearching$ = this.store.select(
		FireInsuranceAgentsSearchState.getSearching,
	);
	public fireInsuranceCompany = this.store.selectSnapshot(
		SelectedMatter.fireInsuranceCompany,
	);

	@Output() onSelectedAgent = new EventEmitter<FireInsuranceAgent>();
	@Output() onCreateAgent = new EventEmitter<string>();

	constructor(
		private store: Store,
		private fireInsuranceAgentsDispatch: FireInsuranceAgentsDispatch,
	) {}

	public onSelect(ev: DropdownResult<FireInsuranceAgent>) {
		if (ev.group === 1) {
			const { result } = ev;
			this.onSelectedAgent.emit(result);
		}
	}

	public search = ($event) => {
		this.fireInsuranceAgentsDispatch.Search(
			$event,
			this.fireInsuranceCompany.id,
		);
		this.searchTerm = $event;
	};

	public createAgent = () => {
		this.onCreateAgent.emit(this.searchTerm);
	};
}
